<script>
import Alert from '../Components/Alert.vue';
import alert from '../Components/Alert.vue';

export default {
  components: { Alert },

  props: {},

  data() {
    return {
      alerts: this.$page.props.alerts,
    };
  },
  computed: {
    alert() {
      return alert;
    },
  },

  methods: {
    alertClass(alert) {
      if (alert === null) {
        return '';
      }

      if (alert.class == null) {
        return 'outline alert-secondary';
      }
      return alert.class;
    },
  },
};
</script>

<template>
  <Alert
    v-for="alert in alerts"
    v-if="alert !== null"
    :dismissible="alert?.dismissable ?? false"
    :class="alertClass(alert)"
    :icon="alert?.icon"
  >
    <strong>{{ alert?.title }}</strong> <span v-html="alert?.body" />
  </Alert>
</template>
